/**
 * @generated SignedSource<<c4e8f81932fdca79db60b63cc208a4d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TreeStatesTable_Refetch$variables = {
  after?: string | null | undefined;
  filterByRootNodeId?: string | null | undefined;
  filterByUserId?: string | null | undefined;
  first?: number | null | undefined;
};
export type TreeStatesTable_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TreeStatesTable_QueryFragment">;
};
export type TreeStatesTable_Refetch = {
  response: TreeStatesTable_Refetch$data;
  variables: TreeStatesTable_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByRootNodeId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByUserId"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filterByRootNodeId",
    "variableName": "filterByRootNodeId"
  },
  {
    "kind": "Variable",
    "name": "filterByUserId",
    "variableName": "filterByUserId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TreeStatesTable_Refetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "TreeStatesTable_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TreeStatesTable_Refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnV2AdminSchema",
            "kind": "LinkedField",
            "name": "LearnV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "TreeStatesConnection",
                "kind": "LinkedField",
                "name": "GetTreeStates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeStatesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TreeState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TreeNode",
                            "kind": "LinkedField",
                            "name": "rootNode",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "structureDefinition",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v4/*: any*/)
                                    ],
                                    "type": "RootStructureDefinition",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "userExtensionKind",
                                    "value": "InfectopharmUserExtension"
                                  }
                                ],
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extension",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "firstName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "lastName",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "salutation",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "InfectopharmUserExtension",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": [
                  "filterByRootNodeId",
                  "filterByUserId"
                ],
                "handle": "connection",
                "key": "TreeStatesTable_GetTreeStates",
                "kind": "LinkedHandle",
                "name": "GetTreeStates"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f099456bf03e184c23d14fd0f3e535bf",
    "id": null,
    "metadata": {},
    "name": "TreeStatesTable_Refetch",
    "operationKind": "query",
    "text": "query TreeStatesTable_Refetch(\n  $after: String\n  $filterByRootNodeId: ID\n  $filterByUserId: ID\n  $first: Int = 10\n) {\n  ...TreeStatesTable_QueryFragment_1lstX1\n}\n\nfragment ActionColumn_TreeStateFragment on TreeState {\n  id\n}\n\nfragment ProjectUserDescription_UserFragment on User {\n  ...UserDescription_UserFragment\n}\n\nfragment TitleColumn_TreeStateFragment on TreeState {\n  rootNode {\n    structureDefinition {\n      __typename\n      ... on RootStructureDefinition {\n        title\n      }\n    }\n    id\n  }\n}\n\nfragment TreeStatesTable_QueryFragment_1lstX1 on Query {\n  Admin {\n    LearnV2 {\n      GetTreeStates(first: $first, after: $after, filterByRootNodeId: $filterByRootNodeId, filterByUserId: $filterByUserId) {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            ...TreeStatesTable_TreeStateFragment\n            id\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n}\n\nfragment TreeStatesTable_TreeStateFragment on TreeState {\n  ...ActionColumn_TreeStateFragment\n  ...TitleColumn_TreeStateFragment\n  ...UserColumn_TreeStateFragment\n}\n\nfragment UserColumn_TreeStateFragment on TreeState {\n  user {\n    ...ProjectUserDescription_UserFragment\n    id\n  }\n}\n\nfragment UserDescription_UserFragment on User {\n  extension(userExtensionKind: InfectopharmUserExtension) {\n    __typename\n    ... on InfectopharmUserExtension {\n      firstName\n      lastName\n      title\n      salutation\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d327fb087238f85f8b1f5e17d3c40c4d";

export default node;
